export default {
  "privacy": {
    "heroTitle": "隐私政策",
    "lastUpdated": "最后更新：2026年8月3日",
    "sections": [
      {
        "title": "1. 引言",
        "paragraphs": [
          "IS TELECOM（以下简称「我们」或「IS TELECOM」）致力于保护其用户、客户和合作伙伴的隐私和个人数据。本隐私政策解释了我们如何在您使用我们的网站 is-telecom.co（以下简称「本网站」）或与我们互动时收集、使用、存储和保护您的个人数据。",
          "使用本网站或向我们提供您的个人数据，即表示您接受本隐私政策中描述的做法。如果您不接受本政策，请不要使用本网站。"
        ]
      },
      {
        "title": "2. 数据控制者",
        "paragraphs": [
          "通过本网站收集的个人数据的数据控制者是 IS TELECOM，位于贝宁科托努。",
          "电话：+229 01 95 89 27 55 — 邮箱：contact@is-telecom.co"
        ]
      },
      {
        "title": "3. 收集的数据",
        "paragraphs": ["我们收集以下类别的个人数据："],
        "list": [
          "身份数据：名字、姓氏、公司名称",
          "联系数据：邮箱地址、电话号码、邮寄地址",
          "项目相关数据：项目类型、地点、预估预算、需求描述",
          "浏览数据：IP地址、浏览器类型、访问页面、访问时长"
        ]
      },
      {
        "title": "4. 处理目的",
        "paragraphs": ["您的个人数据被收集和处理用于以下目的："],
        "list": [
          "回应请求：处理您的报价、联系和信息请求",
          "客户关系管理：跟踪您的项目、准备报价、管理合同",
          "沟通：通知您我们的服务、新闻和优惠（经您同意）",
          "网站改进：分析网站使用情况以改进内容和导航",
          "法律义务：遵守我们的法律、法规和税务义务"
        ]
      },
      {
        "title": "5. 处理的法律依据",
        "paragraphs": ["对您个人数据的处理基于以下法律依据之一："],
        "list": [
          "合同履行：当处理为履行合同所必需时",
          "同意：当您已明确同意时",
          "合法利益：当处理为 IS TELECOM 的合法利益所必需时",
          "法律义务：当处理为遵守法律义务所必需时"
        ]
      },
      {
        "title": "6. 保留期限",
        "paragraphs": ["您的个人数据在严格必要的时间内保留："],
        "list": [
          "联系/报价请求：自最后一次联系起3年",
          "客户和合同数据：自合同结束起10年",
          "新闻通讯和营销：直到您撤回同意",
          "浏览数据（cookies）：最长13个月"
        ]
      },
      {
        "title": "7. 数据共享",
        "paragraphs": [
          "IS TELECOM 不会向第三方出售或出租您的个人数据。但是，您的数据可能会与以下方共享：服务提供商（网站托管、分析工具、邮件服务）、法律要求时的主管当局，或仅在您事先同意的情况下与商业伙伴共享。"
        ]
      },
      {
        "title": "8. 数据安全",
        "paragraphs": [
          "IS TELECOM 实施适当的技术和组织措施来保护您的个人数据：传输中的数据加密（HTTPS/TLS）、基于角色的访问限制、员工培训、定期监控和审计。"
        ]
      },
      {
        "title": "9. 您的权利",
        "paragraphs": [
          "根据适用法律，您拥有以下权利：访问权、更正权、删除权、限制权、反对权、数据可携权。"
        ]
      },
      {
        "title": "10. Cookies 和类似技术",
        "paragraphs": [
          "本网站使用必要型、性能型、功能型和定向型 cookies。您可以通过浏览器设置管理您的偏好。"
        ]
      },
      {
        "title": "11. 国际传输",
        "paragraphs": [
          "IS TELECOM 在50多个国家开展业务。您的数据可能会在您居住国以外的国家传输和处理，并采取适当保护措施保护您的数据。"
        ]
      },
      {
        "title": "12. 政策变更",
        "paragraphs": [
          "IS TELECOM 保留随时修改本隐私政策的权利。任何修改将在本页面上发布并附上更新日期。"
        ]
      },
      {
        "title": "13. 联系方式",
        "paragraphs": [
          "如有关于本隐私政策的任何问题或行使您的权利，请联系我们：IS TELECOM — 数据保护官，贝宁科托努。电话：+229 01 95 89 27 55。邮箱：contact@is-telecom.co"
        ]
      }
    ]
  }
};